module.exports = __webpack_public_path__ + "img/27_23.14948c37.png";